import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import enTranslation from './locales/en.json';
import plTranslation from './locales/pl.json';
import frTranslation from './locales/fr.json';

// Define language resources
const resources = {
    en: {
        translation: enTranslation
    },
    pl: {
        translation: plTranslation
    },
    fr: {
        translation: frTranslation
    }
};

// Detect browser language
const getBrowserLanguage = (): string => {
    const browserLang = navigator.language.split('-')[0];
    return ['en', 'pl', 'fr'].includes(browserLang) ? browserLang : 'en';
};

// Initialize i18next
i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem('language') || getBrowserLanguage(),
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // React already escapes values
        },
        react: {
            useSuspense: true
        }
    });

export default i18n; 